package net.gorillagroove.util

import kotlinx.serialization.json.*

val JsonElement.string get(): String {
    return (this as JsonPrimitive).contentOrNull!!
}
val JsonElement.long get(): Long {
    return (this as JsonPrimitive).longOrNull!!
}
